export const notifyWithFullscreenClose = (player, data) => {
  console.log('FULL screen data>>>', data);
  if (player.isFullscreen_) {
    const btn = document.getElementsByClassName('vjs-fullscreen-control')[0];
    if (btn) {
      btn.click(true);
    }
    setTimeout(() => {
      parent.postMessage(data, '*');
    }, 500);
  } else {
    parent.postMessage(data, '*');
  }
};
